let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a6X4y")).then(() => parcelRequire('4JTpJ'));